module.exports = __webpack_public_path__ + "assets/icons/ic_plus_one-1cf8.svg";